export default __webpack_public_path__ + "static/media/VIBees.98ebd375.JPG";